import React from "react";
import { connect } from "react-redux";
import history from "../history";
import {
  setLoader,
  setDefaultBillingAddress,
  setDefaultShippingAddress,
} from "../actions";

class DefaultAddressPopup extends React.Component {
  // Helper to get street from address (handles array or string)
  getStreet = (address) => {
    if (!address) return '';
    if (Array.isArray(address.street)) return address.street[0] || '';
    return address.street || '';
  };

  // Helper to get region code from address (handles various formats)
  getRegionCode = (address) => {
    if (!address) return '';
    if (address.region_code) return address.region_code;
    if (address.regionCode) return address.regionCode;
    if (address.region?.region_code) return address.region.region_code;
    if (typeof address.region === 'string') return address.region;
    return '';
  };

  renderAddresses = () => {
    if (this.props.addresses && this.props.addresses.length > 0) {
      return this.props.addresses.map((v, index) => {
        const street = this.getStreet(v);
        const regionCode = this.getRegionCode(v);

        return (
          <div
            key={v.id || index}
            className="account-shipping-address"
            style={{ position: "relative" }}
          >
            <div>
              {v.firstname} {v.lastname}
            </div>
            {v.telephone && <div>tel: {v.telephone}</div>}
            {street && <div>{street}</div>}
            <div>
              {v.city} {regionCode} {v.postcode}
            </div>
            <button
              style={{
                position: "absolute",
                top: 18,
                right: 0,
                background: "#bfdd00",
                color: "#022a1e",
                borderRadius: 20,
                width: 100,
              }}
              onClick={() => {
                if (this.props.billing) {
                  const new_default_billing = v.id;
                  this.props.setLoader(true, "Updating Billing...");
                  this.props.setDefaultBillingAddress(
                    new_default_billing,
                    () => {
                      this.props.setLoader(false, null);
                      // Close popup - parent will reload addresses
                      this.props.onClickMask();
                    }
                  );
                } else if (this.props.shipping) {
                  const new_default_shipping = v.id;
                  this.props.setLoader(true, "Updating Shipping...");
                  this.props.setDefaultShippingAddress(
                    new_default_shipping,
                    () => {
                      this.props.setLoader(false, null);
                      // Close popup - parent will reload addresses
                      this.props.onClickMask();
                    }
                  );
                }
              }}
            >
              Set
            </button>
          </div>
        );
      });
    } else {
      return <div className="text-muted">No addresses available</div>;
    }
  };

  render() {
    console.log("address", this.props.addresses); // array
    console.log("billing", this.props.billing); // true or false
    console.log("shipping", this.props.shipping); // true or false

    const heading_css = {
      textAlign: "center",
      fontSize: 20,
    };

    return (
      <div id="default-address-mask" onClick={this.props.onClickMask}>
        <div id="default-address-modal">
          {this.props.billing && (
            <div style={heading_css}>Set Default Billing</div>
          )}
          {this.props.shipping && (
            <div style={heading_css}>Set Default Shipping</div>
          )}
          {this.renderAddresses()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {
  setLoader,
  setDefaultBillingAddress,
  setDefaultShippingAddress,
})(DefaultAddressPopup);
